import { listenFunnelCollection, FunnelName, FunnelCollectionName } from "../../firebase";

export const listenPolicyProposalURL = ({ ...listenOptions }): Promise<string> =>
  new Promise((resolve, reject) => {
    const onSnapshot = snapshot => {
      const { policy } = snapshot.data();
      if (policy && policy.proposal && policy.proposal.url) {
        // eslint-disable-next-line
        unlisten();
        resolve(policy.proposal.url);
      }
    };

    const unlisten = listenFunnelCollection({
      ...listenOptions,
      funnelName: FunnelName.Cicl,
      name: FunnelCollectionName.Checkout,
      onSuccess: onSnapshot,
      onError: reject
    });
  });
